// assets
import { MenuIcon } from 'components/ui-component/icons';

// ==============================|| SUPER ADMIN MENU ITEMS ||============================== //
const icons = {
    MenuIcon: () => <MenuIcon size="20px" />
};

const superadmin_nav = [
    {
        id: 'company-contractmanagement',
        title: '계약업체 현황 및 정보관리',
        type: 'group',
        icon: icons.MenuIcon,
        url: '',
        children: [
            {
                id: 'management-company-info',
                title: '회사정보',
                type: 'item',
                url: '/management/company-info'
            },
            // {
            //     id: 'management-company-contract',
            //     title: '회사별 계약정보',
            //     type: 'item',
            //     url: '/management/company-contract'
            // },
            {
                id: 'login-history-check',
                title: '로그인기록확인',
                type: 'item',
                url: '/management/login-history-check'
            },
            {
                id: 'company-basic-info',  // 변경됨
                title: '정보 설정',
                type: 'collapse',
                url: '/management',
                children: [
                    {
                        id: 'management-department-position',
                        title: '부서·직급 정보',
                        type: 'item',
                        url: '/management/basic-info/department'
                    },
                    {
                        id: 'management-attendance-info',
                        title: '근태정보',
                        type: 'item',
                        url: '/management/basic-info/attendance'
                    },
                    {
                        id: 'management-holiday-info',
                        title: '휴일정보',
                        type: 'item',
                        url: '/management/basic-info/holiday'
                    },
                    {
                        id: 'management-salary-info',
                        title: '급여정보',
                        type: 'item',
                        url: '/management/basic-info/salary-item'
                    },
                    {
                        id: 'management-4-insurance',
                        title: '4대보험요율',
                        type: 'item',
                        url: '/management/basic-info/4-insurance'
                    },
                    {
                        id: 'management-simple-tax',
                        title: '간이세액표',
                        type: 'item',
                        url: '/management/basic-info/simple-tax'
                    },
                ]
            },
        ]
    },
    {
        id: 'device-management',
        title: '기기관리',
        type: 'group',
        icon: icons.MenuIcon,
        url: '/terminal',
        children: [
            {
                id: 'beacon-device',
                title: '비콘단말기 관리',
                type: 'item',
                url: '/terminal/beacon'
            },
            {
                id: 'mobile-device',
                title: '등록기기',
                type: 'item',
                url: '/terminal/mobile'
            }
        ]
    },
    {
        id: 'board-management',
        title: '게시물 관리',
        type: 'group',
        icon: icons.MenuIcon,
        url: '/board',
        children: [
            {
                id: 'notice-board',
                title: '공지 게시',
                type: 'item',
                url: '/board/notice'
            },
            {
                id: 'file-board',
                title: '양식 게시',
                type: 'item',
                url: '/board/file'
            }
        ]
    },
];

export default superadmin_nav;